import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Spinner from '../../Components/Spinner/Spinner';
import { validateResetPassword } from './models';
import './UserAdmin.scss';

export const UserAdmin = (): JSX.Element => {

  const [queryParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (queryParams && queryParams.get('e')) {
      validateResetPassword(queryParams.get('e') as string, navigate);
    } else {
      const state = {
        e: '',
        isValid: false
      };

      navigate('/', {state});
    }
  }, [navigate, queryParams]);

  return (
    <main className="nqt-user-admin">
      <Spinner size={90} />
      <header>
        <h3 className="nqt-user-admin--header">please wait, redirecting...</h3>
      </header>
    </main>
  );
};

export default UserAdmin;